import { unwrapResult } from "@reduxjs/toolkit";
import ToastHelper from "../../../../../helpers/ToastHelper";
import {
  requestGetListPet,
  requestUpdatePet,
} from "../../../../../redux/slices/adminSlice";
import { Form, Modal, Input, Select } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const ModalEditPet = (props) => {
  const { currentPet, modalShow, setModalShow } = props;

  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const handleCancel = () => {
    setModalShow(false);
    // setCurrentCompany(null);
  };

  const handleUpdate = async () => {
    const data = form.getFieldsValue();
    const res = unwrapResult(await dispatch(requestUpdatePet(data)));
    const { error } = res;
    if (!error) {
      ToastHelper.showSuccess("Cập nhật thông tin thành công");
      dispatch(requestGetListPet({ page: 1, size: 20 }));
      setModalShow(false);
    } else {
      ToastHelper.showError("Có lỗi xảy ra, vui lòng thử lại.");
      setModalShow(false);
    }
  };

  useEffect(() => {
    form.setFieldsValue(currentPet);
  }, [currentPet, modalShow]);

  const optionsGender = [
    {
      label: "Đực - Male",
      value: "Đực - Male",
    },
    {
      label: "Cái - Female",
      value: "Cái - Female",
    },
  ];
  return (
    <div>
      <Modal
        width="800px"
        forceRender
        destroyOnClose
        open={modalShow}
        onOk={handleUpdate}
        onCancel={handleCancel}
        title={<div className="text-2xl">Chỉnh sửa thông tin thú cưng</div>}
        centered
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Form form={form}>
          <div className="border-t-[1px] pt-4">
            <div className="grid grid-cols-2 gap-8">
              <div className="col-span-1">
                <div>
                  <span className="text-lg font-medium">Mã định danh</span>
                  <Form.Item name="idCode">
                    <Input />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">Tên thú cưng</span>
                  <Form.Item name="name">
                    <Input placeholder="Tên thú cưng" />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">Loài</span>
                  <Form.Item name="species">
                    <Input placeholder="Loài" />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">Giới tính</span>
                  <Form.Item name="gender">
                    <Select options={optionsGender} placeholder="Giới tính" />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">Ảnh nhận diện</span>
                  <Form.Item name="image">
                    <Input placeholder="Ảnh nhận diện" />
                  </Form.Item>
                </div>
              </div>
              <div className="col-span-1">
                <div>
                  <span className="text-lg font-medium">Mã chip</span>
                  <Form.Item name="chipCode">
                    <Input />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">Tên chủ</span>
                  <Form.Item name="owner">
                    <Input placeholder="Tên chủ" />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">Giống</span>
                  <Form.Item name="breed">
                    <Input placeholder="Giống" />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">Trạng thái</span>
                  <Form.Item name="state">
                    <Input placeholder="Trạng thái" />
                  </Form.Item>
                </div>
                <div>
                  <span className="text-lg font-medium">
                    Ảnh nhận diện khác
                  </span>
                  <Form.Item name="image2">
                    <Input placeholder="Ảnh nhận diện khác" />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div>
              <span className="text-lg font-medium">Mô tả</span>
              <Form.Item name="description">
                <Input.TextArea rows={3} placeholder="Mô tả" />
              </Form.Item>
            </div>
            <Form.Item name="id" className="hidden" />
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalEditPet;
